import { render, staticRenderFns } from "./DesarmaderoTVehiculoTBaja.vue?vue&type=template&id=36db5c91&"
import script from "./DesarmaderoTVehiculoTBaja.vue?vue&type=script&lang=js&"
export * from "./DesarmaderoTVehiculoTBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VEditDialog,VTextField})
